import type { DeepPartial } from '@luna/utils-ts';

import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';

export const loans: DeepPartial<LoanFeatureConfig> = {
    overview: {
        enabled: true,
        showAdditionalInfo: true,
        showExtraInstallment: true,
    },
    dashboard: {
        showOutstandingDebt: true,
    },
    settingsDetails: {
        displayAccountOwner: true,
        displaySpacedBBAN: true,
    },
    statements: {
        enabled: true,
    },
    transactions: {
        enabled: true,
        mode: 'flag',
    },
    layout: {
        productInfo: {
            formatAccountNumber: true,
        },
    },
};
